import NewsQuestionView from './news-question-view'
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import $ from 'init/jquery'
import { ItemComment } from 'es6/models/item-comment'
import {
  CQC_COMMAND_TYPES,
  CQC_COMMAND_EVENT,
} from 'es6/constants'

/**
 * Вид для блока "Вопрос-ответ" в новостях.
 * @param {number} itemId ID товара
 * @param {Object} FormView - FormView класс формы вопроса/ответа
 * @param {jQuery} popupOpener - элемент по клику на который открывается попап
 * @param {BodyView} bodyView - вид страницы
 */
@Defaults({
  el: '.questions-container',
  childViews: [],
  events: {
    'click .button_questions_more': 'getMoreQuestions',
    'click .js-log-in': 'openAuthorization',
    'click .js-register': 'openRegistration',
  },
  questionFormTemplate: '#product-questions-form-template',
  needAuthTemplate: '#questions-need-auth-template',
  additionalOptions: [
    'itemId',
    'FormView',
    'popupOpener',
    'bodyView',
  ],
  answerField: 'answers',
})
export class NewsQuestionsView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.childViews.questions = []
    this.initTemplates()
    this._initQuestionForm()
    this.initEventListeners()
    this.collection.fetch()
  }

  /**
   * Инициализация шаблонов.
   */
  initTemplates () {
    this.needAuthTemplate = getTemplate(this.needAuthTemplate)
  }

  /**
   * Инициализация обработки событий.
   */
  initEventListeners () {
    this.listenTo(this.collection, 'sync', this.renderQuestions)
    this.listenTo(this.childViews.questionForm, 'newQuestionAnswer', this.addQuestionAnswer)
  }

  /**
   * Получить все вопросы
   */
  getMoreQuestions () {
    this.collection.showAll = true
    this.collection.fetch()
  }

  /**
   * Отрисовка формы вопроса.
   * @private
   */
  _initQuestionForm () {
    // если пользователь не авторизован, то выводим требование об авторизации
    if (!this.user.has('id')) {
      this.$('.js-question-form').html(this.needAuthTemplate)
    } else {
      if (!this.childViews.questionForm) {
        this.childViews.questionForm = new this.FormView({
          el: $('.js-question-form'),
          isAnswer: false,
          itemId: this.itemId,
          user: this.user,
        })
        this.childViews.questionForm.render()
      }
    }
  }

  /**
   * Отрисовка вопросов первого уровня.
   */
  renderQuestions () {
    this.$('.js-questions').html('')
    const fragment = document.createDocumentFragment()
    this.collection.forEach(question => {
      fragment.appendChild(this.createQuestionView(question))
    })
    this.$('.js-questions').append(fragment)
    if (this.collection.state.pageCount > 1 && !this.collection.showAll) {
      this.$('.button_questions_more').removeClass('not_display')
      this.$('.hidden-questions-qty').html(' ' + this.collection.state.totalCount - this.collection.state.perPage)
    }
    if (this.collection.showAll) {
      this.$('.button_questions_more').addClass('not_display')
    }
  }

  /**
   * Добавление вопроса в коллекцию | ответа в DOM
   * @param {Object} data - объект вопроса
   */
  addQuestionAnswer (data) {
    if (data.isAnswer) {
      const $answersWrapper = this.$(`[data-question-id=${data.response.item_question_id}] > .js-answers-block`)
      $answersWrapper.append(this.createQuestionView(new ItemComment(data.response), data.isAnswer))
    } else {
      this.collection.add(data.response, { at: 0 })
      this.collection.trigger('sync')
    }
  }

  /**
   * Инициализация view, render вопроса.
   * @param {ItemComment} model Модель вопросов.
   * @param {boolean} [isAnswer] Признак ответа.
   * @returns {HTMLElement} DOM-элемент вопроса\ответа.
   */
  createQuestionView (model, isAnswer) {
    const view = new NewsQuestionView(Object.assign({
      model,
      item: this.item,
      user: this.user,
      isMobile: this.isMobile,
      resolveReplies: this.resolveReplies,
      answerTemplateSelector: this.answerTemplateSelector,
    }, isAnswer && {
      templateSelector: NewsQuestionView.prototype.answerTemplateSelector,
    }))
    this.childViews.questions.push(view)
    return view.render().el
  }

  /**
   * Открытие формы авторизации.
   * @param {MouseEvent} event Событие клика мышью
   */
  openAuthorization (event) {
    event.preventDefault()
    Backbone.trigger(CQC_COMMAND_EVENT, {
      type: CQC_COMMAND_TYPES.showAuthForm,
    })
  }

  /**
   * Открытие формы регистрации.
   * @param {MouseEvent} event Событие клика мышью
   */
  openRegistration (event) {
    event.preventDefault()
    Backbone.trigger(CQC_COMMAND_EVENT, {
      type: CQC_COMMAND_TYPES.showRegistrationForm,
    })
  }
}
